import { render, staticRenderFns } from "./ShopType.vue?vue&type=template&id=c10c9fd0"
import script from "./ShopType.vue?vue&type=script&lang=js"
export * from "./ShopType.vue?vue&type=script&lang=js"
import style0 from "./ShopType.vue?vue&type=style&index=0&id=c10c9fd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports